import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface BlogsTagsObject {
  id: number;
  titleAr: string;
  titleEn: string;
  isActive: boolean;
}

export interface BlogsTagsListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  tags: Array<BlogsTagsObject>;
  errors: unknown;
}

@Module
export default class BlogTagsModule
  extends VuexModule
  implements BlogsTagsListInfo
{
  tags = [] as Array<BlogsTagsObject>;
  allBlogTags = [] as Array<BlogsTagsObject>;

  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get blog tags list
   * @returns Array<BlogsTagsObject>
   */
  get blogTagsList(): Array<BlogsTagsObject> {
    return this.tags;
  }

  /**
   * Get all blog tags list
   * @returns Array<BlogsTagsObject>
   */
  get allListBlogsTags(): Array<BlogsTagsObject> {
    return this.allBlogTags;
  }

  /**
   * Get total items
   * @returns number
   */
  get tagsListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_BLOG_TAGS](data) {
    this.tags = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_BLOG_TAGS_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.SET_ALL_BLOG_TAGS](data) {
    this.allBlogTags = data.data;
  }

  @Mutation
  [Mutations.RESET_BLOG_TAGS_LIST]() {
    this.tags = [] as Array<BlogsTagsObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.RESET_BLOG_TAGS_STORE]() {
    this.context.commit(Mutations.RESET_BLOG_TAGS_LIST);
  }

  @Action
  [Actions.CREATE_BLOG_TAG](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/blog-tags', data)
      .then(({ data }) => {
        this.context.commit(Mutations.RESET_BLOG_TAGS_LIST);
        return data.data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_BLOG_TAG](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/blog-tags', id)
      .then(() => {
        this.context.commit(Mutations.RESET_BLOG_TAGS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_BLOG_TAG]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/blog-tags', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_BLOG_TAGS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_BLOG_TAGS_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_BLOG_TAGS_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_BLOG_TAG](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/blog-tags', id);
  }

  @Action
  [Actions.GET_BLOG_TAGS]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/blog-tags', {
      params: { page: this.currentPage },
    })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_BLOG_TAGS, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.GET_ALL_BLOG_TAGS]() {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/blog-tags/all')
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ALL_BLOG_TAGS, data);
        return data.data;
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }
}
